import { render, staticRenderFns } from "./UserNotesComponent.vue?vue&type=template&id=913e6e62"
import script from "./UserNotesComponent.vue?vue&type=script&lang=js"
export * from "./UserNotesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports